# Naive check to see if it looks like the text contains a URL
module.exports = (text) ->
  /// \b https?:// ///.test(text)



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/contains-url.coffee